<template>
  <div
    :class="[
      $style.container,
      {
        [$style.containerActive]: isActive
      }
    ]"
  >
    <div
      :class="[
      $style.avatarWrap,
      {
        [$style.blue]: iconBackgroundColor === 'blue',
        [$style.none]: iconBackgroundColor === 'none'
      }
    ]"
    >
      <slot name="icon" />
    </div>
    <div :class="$style.info">
      <div :class="$style.topInfo">
        <div :class="$style.title">
          <slot name="default" />
        </div>
        <div :class="$style.corner">
          <slot name="corner" />
        </div>
      </div>
      <div :class="$style.message">
        <slot name="info" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar-list-item',
  props: {
    // isOwn: Boolean,
    isActive: Boolean,
    iconBackgroundColor: {
      type: String,
      validator (value) {
        return ['blue', 'none'].indexOf(value) !== -1
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  align-items: center;
  height: 76px;
  padding: 10px 10px 10px 14px;
  cursor: pointer;

  &:hover:not(&Active) {
    background-color: rgba($main-bg-darkest, 0.1);
  }
  &Active {
    background-color: $main-bg-darkest;
    color: $text-lightest;
    .title {
      color: $text-lightest;
    }
    .corner:hover {
      color: $text-lightest;
    }
  }
  // &Own {
  //   .avatarWrap {
  //     background-color: $blue;
  //   }
  // }
}
.info {
  padding-left: 10px;
  flex-basis: 0;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.topInfo {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.title,
.message {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.title {
  font-size: 16px;
  font-weight: 500;
  padding-right: 4px;
  color: $text-darkest;
}
.corner {
  color: $text-mid-dark;
  &:hover {
    color: $text-dark;
  }
}
.message {
  color: $text-mid-dark;
  margin-top: 4px;
}
.avatarWrap {
  width: 56px;
  height: 56px;
  border-radius: 100%;
  background-color: $main-bg-colored;
  color: $text-lightest;
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  overflow: hidden;

  &.blue {
    background-color: $blue;
  }
  &.none {
    background-color: $transparent;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
</style>
